var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBGeyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#DCDDDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15.2917C7.7875 11.4883 11.2192 8.625 15.3333 8.625C19.4475 8.625 22.8792 11.4883 23.6667 15.2917C22.8792 19.095 19.4475 21.9583 15.3333 21.9583C11.2192 21.9583 7.7875 19.095 7 15.2917ZM15.3333 19.4583C16.4384 19.4583 17.4982 19.0193 18.2796 18.2379C19.061 17.4565 19.5 16.3967 19.5 15.2917C19.5 14.1866 19.061 13.1268 18.2796 12.3454C17.4982 11.564 16.4384 11.125 15.3333 11.125C14.2283 11.125 13.1685 11.564 12.3871 12.3454C11.6057 13.1268 11.1667 14.1866 11.1667 15.2917C11.1667 16.3967 11.6057 17.4565 12.3871 18.2379C13.1685 19.0193 14.2283 19.4583 15.3333 19.4583ZM15.3333 17.7917C15.9964 17.7917 16.6323 17.5283 17.1011 17.0594C17.5699 16.5906 17.8333 15.9547 17.8333 15.2917C17.8333 14.6286 17.5699 13.9927 17.1011 13.5239C16.6323 13.0551 15.9964 12.7917 15.3333 12.7917C14.6703 12.7917 14.0344 13.0551 13.5656 13.5239C13.0967 13.9927 12.8333 14.6286 12.8333 15.2917C12.8333 15.9547 13.0967 16.5906 13.5656 17.0594C14.0344 17.5283 14.6703 17.7917 15.3333 17.7917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0391 7L7.03906 23",
    stroke: "#FFFFFE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBGeyeOff);
export default __webpack_public_path__ + "static/media/BGeyeOff.40e1a410d524060dd86488d9cdb49bc5.svg";
export { ForwardRef as ReactComponent };